import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, OneToOne } from 'typeorm';
import { BaseEntite, EntiteStatique, FiltrableEntiteStatique, Produit } from '.';
import Facturation from './facturation.entity';

@FiltrableEntiteStatique<HistoriquePrixProduit>()
@EntiteStatique()
@Entity('historique_prix_produit')
export class HistoriquePrixProduit implements BaseEntite {
    static key = 'historique_prix_produit';

    static non_privileged_properties: (keyof HistoriquePrixProduit)[] = [];
    static regular_privileged_properties: (keyof HistoriquePrixProduit)[] = ['id', 'name'];
    static admin_privileged_properties: (keyof HistoriquePrixProduit)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @Column({ nullable: true })
    fk_id_produit: number;

    @ManyToOne(() => Produit, (produit) => produit.id)
    @JoinColumn({ name: 'fk_id_produit', referencedColumnName: 'id' })
    produit: Produit;

    @Column({ type: 'date', nullable: true })
    date_debut: string = null;

    @Column({ nullable: true })
    fk_id_facturation: number;

    @OneToOne(() => Facturation, { eager: true, cascade: true })
    @JoinColumn({ name: 'fk_id_facturation', referencedColumnName: 'id' })
    facturation: Facturation;
}

export type HistoriquePrixProduitAvecDateFin = HistoriquePrixProduit & {
    date_fin: string;
};
